<template src="./TicketFormDialog.html"></template>

<script>
import { createTicket, updateTicket } from '../../services'
import { ticketPriorityVal, ticketStatusVal } from '../../utils/constants'
import TicketAssigneeSelect from '../Ticket/TicketAssigneeSelect.vue'
import ProjectSelect from '../Project/ProjectSelect.vue'

const emptyForm = () => ({
  title: '',
  description: '',
  priority: 'NO_PRIORITY',
  dueDate: null,
  assigneeIds: [],
  projectId: null,
  status: 'BACKLOG'
})

export default {
  name: 'TicketFormDialog',
  components: { TicketAssigneeSelect, ProjectSelect },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // Si viene con `id`, el diálogo edita; si no, crea.
    ticket: {
      type: Object,
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'update'
  },
  data: () => ({
    form: emptyForm(),
    priorityOptions: ticketPriorityVal,
    statusOptions: ticketStatusVal,
    saving: false,
    rules: { required: (val) => !!val || 'Campo requerido' }
  }),
  computed: {
    isEditing () {
      return !!(this.ticket && this.ticket.id)
    },
    dialogTitle () {
      return this.isEditing ? 'Editar ticket' : 'Nuevo ticket'
    }
  },
  watch: {
    value (isOpen) {
      if (isOpen) { this.resetForm() }
    }
  },
  methods: {
    resetForm () {
      if (this.isEditing) {
        this.form = {
          title: this.ticket.title,
          description: this.ticket.description || '',
          priority: this.ticket.priority,
          dueDate: this.ticket.dueDate ? this.ticket.dueDate.substring(0, 10) : null,
          assigneeIds: (this.ticket.assignees || (this.ticket.assignedTo ? [this.ticket.assignedTo] : []))
            .map((assignee) => assignee.id),
          projectId: this.ticket.project ? this.ticket.project.id : null,
          status: this.ticket.status
        }
      } else {
        this.form = emptyForm()
      }
    },
    close () {
      this.$emit('update', false)
    },
    // On a project change the previous assignee may not be a member of the new project, and the
    // backend would reject the save with a 400. Clear the selection so the user picks from the
    // destination project's members.
    onProjectChange () {
      this.form.assigneeIds = []
    },
    async submit () {
      if (!this.$refs.form.validate()) return
      this.saving = true
      try {
        if (this.isEditing) {
          await updateTicket(this.ticket.id, { ...this.form })
        } else {
          // El EP de creación no acepta `status` (todo ticket nace en BACKLOG) — mandarlo violaría
          // la validación Joi ("Invalid request payload input").
          const { status, ...createPayload } = this.form
          await createTicket(createPayload)
        }
        this.$swal({
          text: this.isEditing ? 'Ticket actualizado.' : 'Ticket creado.',
          buttons: false,
          icon: 'success',
          timer: 2500
        })
        this.$emit('saved')
        this.close()
      } catch (error) {
        console.error('Error saving ticket:', error)
        this.$swal({
          text: error.message ?? 'Ocurrió un error, intenta más tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style lang="scss" src="./TicketFormDialog.scss" scoped></style>
